const SHOPPING_CART_ID = 'SEATMAP';

const processIds = ([id] = []) => ({
    ...(id && {id}),
});

const decorate = (data = {}) => {
    const {quantity = 0, selection = {}} = data;

    return {
        ...data,
        id: SHOPPING_CART_ID,
        quantity,
        selection,
    };
};

module.exports = {
    decorate,
    processIds,
    getProductName: () => SHOPPING_CART_ID,
};
